import * as angular from 'angular';
import { Subject } from 'rxjs';
import produce from 'immer';
const initialState = { editingFlow: {}, editingFlowId: '' };
const globalActionInitialState = {};
export class BuilderStore {
    constructor() {
        this.initialState = initialState;
        this.globalActionInitialState = globalActionInitialState;
        this.flow = produce(this.initialState, () => this.initialState);
        this.globalActionFlow = produce(this.globalActionInitialState, () => this.globalActionInitialState);
        this.flowChanges$ = new Subject();
        this.stateChanges$ = new Subject();
        this.globalActionChanges$ = new Subject();
    }
    static getInstance() {
        if (!BuilderStore.instance) {
            BuilderStore.instance = new BuilderStore();
        }
        return BuilderStore.instance;
    }
    getFlowChanges() {
        return this.flowChanges$.asObservable();
    }
    getGlobalActionChanges() {
        return this.globalActionChanges$.asObservable();
    }
    getStateChanges() {
        return this.stateChanges$.asObservable();
    }
    setFlow(flow, flowId) {
        this.flow = produce(this.flow, (draft) => {
            draft.editingFlow = flow;
            draft.editingFlowId = flowId;
        });
        this.flowChanges$.next(this.flow);
    }
    setState(state) {
        this.flow = produce(this.flow, (draft) => {
            draft.editingFlow[state.id] = state;
        });
        this.stateChanges$.next(this.flow.editingFlow[state.id]);
    }
    setGlobalActions(globalAction) {
        this.globalActionFlow = produce(this.globalActionFlow, (draft) => {
            draft.editingGlobalAction = globalAction;
        });
        this.globalActionChanges$.next(this.globalActionFlow.editingGlobalAction);
    }
    getState(stateId) {
        return angular.copy(this.flow.editingFlow[stateId]);
    }
}
